export const labs = ["Houston · Central Laboratory", "Atlantic · Newark", "SGS · Houston refinery demo"];
export const instruments = [
  {
    id: "DIST-04",
    name: "OptiDist",
    maker: "PAC",
    method: "ASTM D86",
    protocol: "XML / MQTT",
    repo: "optidis2_gateway",
    signal: "Heater power, recovery, cut temperatures",
    status: "Attention",
    latency: "2 s",
  },
  {
    id: "DIST-02",
    name: "OptiDist",
    maker: "PAC",
    method: "ASTM D86",
    protocol: "XML / MQTT",
    repo: "PAC-IoTFlows",
    signal: "Run phases, recovery, flask temperatures",
    status: "Connected",
    latency: "2 s",
  },
  {
    id: "FLASH-01",
    name: "OptiFlash",
    maker: "PAC",
    method: "ASTM D93",
    protocol: "Node-RED / MQTT",
    repo: "flows",
    signal: "Ignition events, temperature, pressure",
    status: "Connected",
    latency: "3 s",
  },
  {
    id: "FUEL-01",
    name: "OptiFuel",
    maker: "PAC",
    method: "FTIR screening",
    protocol: "TCP / MQTT",
    repo: "optifuel",
    signal: "Spectra, fuel class, predicted properties",
    status: "Connected",
    latency: "4 s",
  },
  {
    id: "ELEM-01",
    name: "Element NS",
    maker: "PAC",
    method: "ASTM D4629",
    protocol: "ZeroMQ",
    repo: "elementns",
    signal: "Nitrogen, sulfur, instrument diagnostics",
    status: "Connected",
    latency: "2 s",
  },
  {
    id: "DENS-01",
    name: "70Xe",
    maker: "Anton Paar",
    method: "ASTM D4052",
    protocol: "Gateway / MQTT",
    repo: "pace_70xe",
    signal: "Density, cell temperature, results",
    status: "Connected",
    latency: "5 s",
  },
  {
    id: "OCT-01",
    name: "Octane analyzer",
    maker: "CFR",
    method: "ASTM D2699",
    protocol: "MQTT",
    repo: "pace_octane",
    signal: "RON, knock intensity, operating state",
    status: "Connected",
    latency: "3 s",
  },
  {
    id: "VP-01",
    name: "Syrus VP",
    maker: "PAC",
    method: "ASTM D5191",
    protocol: "Gateway / MQTT",
    repo: "pace_syrys_vp",
    signal: "Vapor pressure, chamber temperature",
    status: "Connected",
    latency: "2 s",
  },
  {
    id: "IRIS-01",
    name: "IRIS stream",
    maker: "Multi-vendor",
    method: "Result capture",
    protocol: "Packet adapter",
    repo: "iris-sniffer",
    signal: "Parsed instrument result messages",
    status: "Available",
    latency: "—",
  },
  {
    id: "GC-01",
    name: "Gas chromatograph",
    maker: "Agilent",
    method: "ASTM D5580",
    protocol: "CSV file watcher",
    repo: null,
    signal: "Peaks, retention time, concentration",
    status: "Planned",
    latency: "—",
  },
  {
    id: "ICP-01",
    name: "ICP-OES",
    maker: "Thermo Fisher",
    method: "ASTM D5185",
    protocol: "CSV / LIMS",
    repo: null,
    signal: "Elements, calibration, interference flags",
    status: "Planned",
    latency: "—",
  },
  {
    id: "BAL-01",
    name: "Analytical balance",
    maker: "Mettler Toledo",
    method: "Gravimetry",
    protocol: "RS-232",
    repo: null,
    signal: "Stable weight, units, calibration",
    status: "Planned",
    latency: "—",
  },
];
export const models = [
  {
    id: "M-01",
    name: "Phase-aware drift sentinel",
    repo: "GT26-A3",
    family: "Drift detection",
    input: "Heating rate, recovery, run phase",
    output: "Deviation score + affected time window",
    use: "Early result-quality warning",
    stage: "Demo active",
    limitation:
      "Flash-point research adapted conceptually to D86; requires instrument-specific validation.",
  },
  {
    id: "M-02",
    name: "Flashpoint behavior monitor",
    repo: "GT26-T03",
    family: "Anomaly detection",
    input: "Temperature, pressure, event sequence",
    output: "Anomaly events and drift segments",
    use: "Detect atypical analyzer behavior",
    stage: "Research",
    limitation: "No deployed model weights or performance claims in this demo.",
  },
  {
    id: "M-03",
    name: "Multivariate process sentinel",
    repo: "GT26-A1",
    family: "Time-series classification",
    input: "Aligned process telemetry",
    output: "Normal / fault pattern",
    use: "Cross-sensor process diagnostics",
    stage: "Research",
    limitation: "Research dataset differs from each laboratory installation.",
  },
  {
    id: "M-04",
    name: "Evidence-grounded investigator",
    repo: "GT26-B1",
    family: "Knowledge graph + RAG",
    input: "Asset, sensor, failure relationships + SOPs",
    output: "Cited hypotheses and evidence",
    use: "Defensible root-cause investigation",
    stage: "Demo active",
    limitation:
      "Scripted evidence-based responses; no live LLM endpoint is called.",
  },
  {
    id: "M-05",
    name: "Remaining-life estimator",
    repo: "GT26-T06",
    family: "Prognostics",
    input: "Equipment time series + maintenance labels",
    output: "Remaining useful life estimate",
    use: "Plan service windows",
    stage: "Research",
    limitation:
      "Transfer to lab assets needs run-to-failure history and calibration.",
  },
  {
    id: "M-06",
    name: "Bearing health trend",
    repo: "GT26-T08",
    family: "Health index",
    input: "Vibration features and operating cycles",
    output: "Degradation trend",
    use: "Rotating-equipment maintenance",
    stage: "Research",
    limitation:
      "Catalog entry only; no vibration sensor is connected in this scenario.",
  },
  {
    id: "M-07",
    name: "Sensor-to-failure reasoning",
    repo: "GT26-B2",
    family: "Diagnostic reasoning",
    input: "Failure modes, sensors, diagnostic questions",
    output: "Ranked explanations",
    use: "Evaluate agent grounding and robustness",
    stage: "Research",
    limitation:
      "Research evaluation is not a laboratory validation certificate.",
  },
  {
    id: "M-08",
    name: "Physics-informed anomaly model",
    repo: "GT26-T01",
    family: "Anomaly detection",
    input: "Multivariate process and operating variables",
    output: "Reconstruction residual + fault score",
    use: "Detect departures from expected operation",
    stage: "Research",
    limitation:
      "Candidate model family; application-specific data and acceptance criteria required.",
  },
  {
    id: "M-09",
    name: "Change-point monitor",
    repo: "GT26-T02",
    family: "Change detection",
    input: "Sequential sensor observations",
    output: "Regime-change candidate",
    use: "Identify onset of instrument drift",
    stage: "Research",
    limitation: "Threshold tuning and false-alert validation are pending.",
  },
  {
    id: "M-10",
    name: "Process classification explorer",
    repo: "GT26-A2",
    family: "Classification",
    input: "Process features and labeled events",
    output: "Class probabilities / embeddings",
    use: "Separate operating modes",
    stage: "Research",
    limitation: "Research catalog only; no inference integration.",
  },
];
// Pack identifiers and copy carried over from Trucision's marketplace page.
export const packs = [
  {
    id: "pack-d86",
    oem: "PAC",
    title: "Distillation D86 tip pack",
    detail:
      "Heating-block seating, flask cracks, error 33. Covers all distillation analyzers.",
    items: 12,
    version: "2.3",
  },
  {
    id: "pack-d93",
    oem: "PAC",
    title: "Flash point D93 SOP pack",
    detail: "Ignition-source checks and late-calibration recovery.",
    items: 8,
    version: "1.6",
  },
  {
    id: "pack-qc",
    oem: "Enrisk",
    title: "QC collection SOP pack",
    detail: "Night-shift labeling and failed-QC remediation.",
    items: 6,
    version: "3.1",
  },
];
export const roster = [
  {
    name: "Maya Chen",
    role: "Lab Manager",
    skills: ["Release", "CAPA approval", "D86"],
    level: 3,
    expires: "2027-04-18",
    evidence: "COMP-028",
  },
  {
    name: "Luis Ortega",
    role: "Senior analyst",
    skills: ["D86", "Calibration", "D93"],
    level: 3,
    expires: "2027-02-10",
    evidence: "COMP-041",
  },
  {
    name: "Aisha Patel",
    role: "Analyst",
    skills: ["D86", "D4052", "QC"],
    level: 2,
    expires: "2027-01-22",
    evidence: "COMP-046",
  },
  {
    name: "Evan Brooks",
    role: "Trainee",
    skills: ["Sample receipt"],
    level: 1,
    expires: "2026-11-01",
    evidence: "COMP-052",
  },
];
export const initialWiki = [
  {
    id: "CTX-01",
    title: "D86 result-release policy",
    kind: "Decision rule",
    text: "Hold all DIST-04 results after 07:32 when the drift score exceeds 0.70 for three consecutive windows. Release requires a valid alternate-instrument retest, passing QC and manager approval.",
    rev: 4,
    owner: "Maya Chen",
  },
  {
    id: "CTX-02",
    title: "Instrument aliases & sample lineage",
    kind: "Semantic mapping",
    text: "DIST-04 = OptiDist serial OD-24189 = gateway Houston-Distillation-4. run.sample_id joins LIMS sample.id; customer_order links the certificate. Temperature: °C. Recovery: % v/v.",
    rev: 2,
    owner: "Luis Ortega",
  },
  {
    id: "CTX-03",
    title: "SOP-D86-014 · heating assembly",
    kind: "Procedure",
    text: "Inspect flask seating and heating-block contact. Record reference thermometer check. After adjustment run CRM-241 and retain the trace. Return to service requires authorized review.",
    rev: 7,
    owner: "Luis Ortega",
  },
  {
    id: "CTX-04",
    title: "Northstar terminal contract",
    kind: "Customer context",
    text: "Order NS-1042: diesel terminal acceptance. Report T10, T50, T90 and final boiling point. Delivery due 16:00 CDT. Customer decision limits use the agreed contract revision 3.",
    rev: 3,
    owner: "Maya Chen",
  },
];
export const telemetry = [
 ...Array.from({length:25},(_,i)=>({
  time: `${String(7+Math.floor(i/6)).padStart(2,'0')}:${String((i%6)*10).padStart(2,'0')}`,
  score:Number((i<4?0.15+Math.sin(i)*0.02:0.20+(i-4)*0.024).toFixed(3)),
  heater:Number((i<4?48:48+(i-4)*0.7).toFixed(1)),qcZ:0.4,
 })),
 {time:'11:04',score:0.76,heater:64.2,qcZ:0.4},
 {time:'11:08',score:0.79,heater:64.8,qcZ:0.4},
 {time:'11:12',score:0.82,heater:65.3,qcZ:0.4},
];
